import { createAuthService } from 'src/app/shared/authService/authService';

import { log } from '../logging';

export const authenticate = async (): Promise<void> => {
  const { isAuthenticated, login: redirectToLogin } = createAuthService();

  let isAuth = false;

  try {
    isAuth = await isAuthenticated();
  } catch (error) {
    log.error('authenticate | isAuthenticated', { error });
  }

  if (!isAuth) {
    redirectToLogin();
  }
};
